// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-343d8f34] {\n    font-family: sans-serif;\n}\n[data-v-343d8f34] .chart-label {\n    font-size: 12px;\n    opacity: 0.5;\n}\n.legend-svg[data-v-343d8f34] {\n    -ms-flex-item-align: end;\n        align-self: flex-end;\n    overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
